import { batchLoadingDataSourcePlugin, columnFiltersPlugin, columnsPlugin, dynamicHeightPlugin, localStoragePlugin } from "../plugins";
import { emailBodyCellTemplate } from "../../routes/communications/email_table_utils";

/**
 * @param {Object} options
 * @param {String} options.storageKey
 * @param {Object} options.columnOverrides
 *
 * @returns {import("../datagrid").Pack}
 */
export function emailListPack(options = {}) {
  return ($container) => {
    const dataSourceURL = $container.getAttribute("data-source-url");

    const storagePlugin = options.storageKey !== undefined ? localStoragePlugin(options.storageKey) : [];

    return [
      batchLoadingDataSourcePlugin(dataSourceURL),
      columnFiltersPlugin(),
      columnsPlugin({
        columnDefaults: { visible: true, allowHeaderFiltering: false },
        columnOverrides: options.columnOverrides,
      }),
      dynamicHeightPlugin(),
      emailHistoryStylePlugin(),
      storagePlugin,
    ];
  };
}

function emailHistoryStylePlugin() {
  return {
    options: {
      allowColumnReordering: true,
      columnAutoWidth: true,
      masterDetail: { enabled: true, template: emailBodyCellTemplate },
      showColumnLines: true,
      wordWrapEnabled: true,
    },
  };
}
